var map = {
	"./HDTX Pengumuman RUPS GMS Announcement 2026.pdf": 32,
	"./HDTX_Announcement of Extraordinary GMS 2025.pdf": 33,
	"./HDTX_Announcement of GMS 2023.pdf": 34,
	"./HDTX_Announcement of GMS 2024.pdf": 35,
	"./HDTX_Announcement of GMS 2025.pdf": 36,
	"./HDTX_Announcement_of_GMS_2021.pdf": 37,
	"./HDTX_Announcement_of_GMS_2022.pdf": 38,
	"./HDTX_Annual Report 2018.pdf": 39,
	"./HDTX_Annual Report 2019.pdf": 40,
	"./HDTX_Annual Report 2020.pdf": 41,
	"./HDTX_Annual Report 2021.pdf": 42,
	"./HDTX_Annual Report 2022.pdf": 43,
	"./HDTX_Annual Report 2023.pdf": 44,
	"./HDTX_Annual Report 2024.pdf": 45,
	"./HDTX_Annual Report 2025.pdf": 46,
	"./HDTX_Audit Report 2022.pdf": 47,
	"./HDTX_Audit Report 2023.pdf": 48,
	"./HDTX_Audit Report 2024.pdf": 49,
	"./HDTX_Audit Report 2025.pdf": 50,
	"./HDTX_Buyback_Scrip_English 2025.pdf": 51,
	"./HDTX_Buyback_scripless_English 2025.pdf": 52,
	"./HDTX_FS Perubahan Kegiatan Usaha_resume 2025.pdf": 53,
	"./HDTX_Form Daftar Buyback_Scrip 2025.pdf": 54,
	"./HDTX_Form Daftar Buyback_Scripless 2025.pdf": 55,
	"./HDTX_General Riwayat Hidup Calon Anggota Direksi PT PIR Tbk.pdf": 56,
	"./HDTX_KI Go Private 2025.pdf": 57,
	"./HDTX_KI Perubahan_Tambahan PKU 2025.pdf": 58,
	"./HDTX_KI Tambhn dan atau Perbhn_Buyback Delisting 2025.pdf": 59,
	"./HDTX_Keterbukaan Informasi 2022.pdf": 60,
	"./HDTX_Keterbukaan Informasi 28 Oktober 2022.pdf": 61,
	"./HDTX_Keterbukaan Informasi Perubahan Kegiatan Usaha 2025.pdf": 62,
	"./HDTX_LKTT 2018.pdf": 63,
	"./HDTX_LKTT 2019.pdf": 64,
	"./HDTX_LKTT 2020.pdf": 65,
	"./HDTX_LKTT 2022.pdf": 66,
	"./HDTX_LKTT 2023.pdf": 67,
	"./HDTX_LKTT 2024.pdf": 68,
	"./HDTX_LKTT 2025.pdf": 69,
	"./HDTX_Materi Usulan Perubahan AD_RUPS 2021.pdf": 70,
	"./HDTX_Minutes Summary of AGMS of June 2023.pdf": 71,
	"./HDTX_Minutes Summary of AGMS of June 24_2024.pdf": 72,
	"./HDTX_Minutes Summary of AGMS of June 30_2025.pdf": 73,
	"./HDTX_Pemanggilan RUPS 2021.pdf": 74,
	"./HDTX_Pemanggilan RUPS 2022.pdf": 75,
	"./HDTX_Pemanggilan RUPS 2023.pdf": 76,
	"./HDTX_Pemanggilan RUPS 24 Juni 2024.pdf": 77,
	"./HDTX_Pemanggilan RUPS 30 Juni 2025.pdf": 78,
	"./HDTX_Pemanggilan RUPS LB 2025.pdf": 79,
	"./HDTX_Pengumuman RUPS 2021.pdf": 80,
	"./HDTX_Pengumuman RUPS 2022.pdf": 81,
	"./HDTX_Pengumuman RUPS 2023.pdf": 82,
	"./HDTX_Pengumuman RUPS 2024.pdf": 83,
	"./HDTX_Pengumuman RUPS 2025.pdf": 84,
	"./HDTX_Pengumuman RUPS LB 2025.pdf": 85,
	"./HDTX_Ringkasan Risalah RUPS 24 Juni 2024.pdf": 86,
	"./HDTX_Ringkasan Risalah RUPS 30 Juni 2025.pdf": 87,
	"./HDTX_Ringkasan Risalah RUPS Juni 2023.pdf": 88,
	"./HDTX_Ringkasan Risalah_Minutes Summary EGMS 2025.pdf": 89,
	"./HDTX_Risalah RUPS_Minutes of GMS 2021.pdf": 90,
	"./HDTX_Riwayat Hidup Calon Anggota Dewan Komisaris 2023-2028.pdf": 91,
	"./HDTX_Riwayat Hidup Calon Anggota Direksi 2023-2028.pdf": 92,
	"./HDTX_Summary of GMS July 2022.pdf": 93,
	"./HDTX_The Invitation of GMS 2021.pdf": 94,
	"./HDTX_The Invitation of GMS 2022.pdf": 95,
	"./HDTX_The Invitation of GMS 2023.pdf": 96,
	"./HDTX_The Invitation of GMS 24 Juni 2024.pdf": 97,
	"./HDTX_The Invitation of GMS 30 Juni 2025.pdf": 98,
	"./PAFI_Announcement of Extraordinary GMS 2025.pdf": 99,
	"./PAFI_Announcement of GMS 2021.pdf": 100,
	"./PAFI_Announcement of GMS 2022.pdf": 101,
	"./PAFI_Announcement of GMS 2023.pdf": 102,
	"./PAFI_Announcement of GMS 2024.pdf": 103,
	"./PAFI_Announcement of GMS 2025.pdf": 104,
	"./PAFI_Annual Report 2018.pdf": 105,
	"./PAFI_Annual Report 2019.pdf": 106,
	"./PAFI_Annual Report 2020.pdf": 107,
	"./PAFI_Annual Report 2021.pdf": 108,
	"./PAFI_Annual Report 2022.pdf": 109,
	"./PAFI_Annual Report 2023.pdf": 110,
	"./PAFI_Annual Report 2024.pdf": 111,
	"./PAFI_Annual Report 2025.pdf": 112,
	"./PAFI_Audit Report 2022.pdf": 113,
	"./PAFI_Audit Report 2023.pdf": 114,
	"./PAFI_Audit Report 2024.pdf": 115,
	"./PAFI_Audit Report 2025.pdf": 116,
	"./PAFI_Calon Anggota Direksi dan Dewan Komisaris 2024-2029.pdf": 117,
	"./PAFI_KI Go Private 2025.pdf": 118,
	"./PAFI_LKTT 2018.pdf": 119,
	"./PAFI_LKTT 2019.pdf": 120,
	"./PAFI_LKTT 2020.pdf": 121,
	"./PAFI_LKTT 2022.pdf": 122,
	"./PAFI_LKTT 2023.pdf": 123,
	"./PAFI_LKTT 2024.pdf": 124,
	"./PAFI_LKTT 2025.pdf": 125,
	"./PAFI_Materi Usulan Perubahan AD_RUPS 2021.pdf": 126,
	"./PAFI_Minutes Summary of GMS of June 2023.pdf": 127,
	"./PAFI_Minutes Summary of GMS of June 24, 2024.pdf": 128,
	"./PAFI_Minutes Summary of GMS of June 30, 2025.pdf": 129,
	"./PAFI_Pemanggilan RUPS 2021.pdf": 130,
	"./PAFI_Pemanggilan RUPS 2022.pdf": 131,
	"./PAFI_Pemanggilan RUPS 2023.pdf": 132,
	"./PAFI_Pemanggilan RUPS 24 Juni 2024.pdf": 133,
	"./PAFI_Pemanggilan RUPS 30 Juni 2025.pdf": 134,
	"./PAFI_Pemanggilan RUPS LB 2025.pdf": 135,
	"./PAFI_Pengumuman RUPS 2021.pdf": 136,
	"./PAFI_Pengumuman RUPS 2022.pdf": 137,
	"./PAFI_Pengumuman RUPS 2023.pdf": 138,
	"./PAFI_Pengumuman RUPS 2024.pdf": 139,
	"./PAFI_Pengumuman RUPS 2025.pdf": 140,
	"./PAFI_Pengumuman RUPS GMS Announcement 2026.pdf": 141,
	"./PAFI_Pengumuman RUPS LB 2025.pdf": 142,
	"./PAFI_Ringkasan Risalah RUPS Juni 2023.pdf": 143,
	"./PAFI_Ringkasan Risalah RUPS_24 Juni 2024.pdf": 144,
	"./PAFI_Ringkasan Risalah RUPS_30 Juni 2025.pdf": 145,
	"./PAFI_Ringkasan Risalah_Minutes Summary of EGMS 2025.pdf": 146,
	"./PAFI_Risalah RUPS_Minutes of GMS 2021.pdf": 147,
	"./PAFI_Riwayat Hidup Calon Anggota Direksi 2023.pdf": 148,
	"./PAFI_Summary of GMS July 2022.pdf": 149,
	"./PAFI_The Invitation of GMS 2021.pdf": 150,
	"./PAFI_The Invitation of GMS 2022.pdf": 151,
	"./PAFI_The Invitation of GMS 2023.pdf": 152,
	"./PAFI_The Invitation of GMS 24 Juni 2024.pdf": 153,
	"./PAFI_The Invitation of GMS 30 Juni 2025.pdf": 154
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31;